module.exports = __webpack_public_path__ + "media/assets/images/category/GoodLuck@2x-31ef6265db5c87c4c1ccfd15682d913b.png";